var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E4DFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 15C29.7826 15 28.9348 15.3512 28.3096 15.9763C27.6845 16.6014 27.3333 17.4493 27.3333 18.3333C27.3348 18.5676 27.361 18.8011 27.4115 19.0299L19.8431 22.8141C19.5309 22.4548 19.1455 22.1664 18.7125 21.9685C18.2796 21.7705 17.8093 21.6676 17.3333 21.6667C16.4493 21.6667 15.6014 22.0179 14.9763 22.643C14.3512 23.2681 14 24.1159 14 25C14 25.8841 14.3512 26.7319 14.9763 27.357C15.6014 27.9821 16.4493 28.3333 17.3333 28.3333C17.8095 28.3328 18.28 28.2303 18.7132 28.0326C19.1464 27.835 19.5322 27.5468 19.8447 27.1875L27.4082 30.9701C27.3588 31.199 27.3337 31.4325 27.3333 31.6667C27.3333 32.5507 27.6845 33.3986 28.3096 34.0237C28.9348 34.6488 29.7826 35 30.6667 35C31.5507 35 32.3986 34.6488 33.0237 34.0237C33.6488 33.3986 34 32.5507 34 31.6667C34 30.7826 33.6488 29.9348 33.0237 29.3096C32.3986 28.6845 31.5507 28.3333 30.6667 28.3333C30.1905 28.3339 29.72 28.4364 29.2868 28.6341C28.8536 28.8317 28.4678 29.1199 28.1553 29.4792L20.5918 25.6966C20.6412 25.4677 20.6663 25.2342 20.6667 25C20.6651 24.7662 20.6389 24.5333 20.5885 24.305L28.1569 20.5208C28.4692 20.8799 28.8548 21.168 29.2877 21.3656C29.7206 21.5632 30.1908 21.6659 30.6667 21.6667C31.5507 21.6667 32.3986 21.3155 33.0237 20.6904C33.6488 20.0652 34 19.2174 34 18.3333C34 17.4493 33.6488 16.6014 33.0237 15.9763C32.3986 15.3512 31.5507 15 30.6667 15Z",
    fill: "#7A69BF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.db682207.svg";
export { ForwardRef as ReactComponent };